<div class="container">
  <div class="left">
    <p><span class="green">{{ 'PAGE_NOT_FOUND.TITLE' | translate }}</span></p>
    <p>{{ 'PAGE_NOT_FOUND.TEXT' | translate }}</p>

  </div>

  <div class="right">
    <img class="notfound-img" src="assets/magicpallet_error.png" alt="404-image">
    <span>404</span>
    <app-loading-button [label]="'PAGE_NOT_FOUND.BACK_TO_PALLET' | translate" type="button" size="big"
                        color="primary" routerLink="/">
    </app-loading-button>
  </div>
</div>
